<div class="modal-overlay" role="dialog" aria-modal="true" aria-labelledby="historyModalTitle">
  <div class="modal-box release-history-modal-box">
    <!-- Pinned Header -->
    <div class="modal-header">
      <div class="modal-title-group">
        <h3 id="historyModalTitle">🕝 CoinSing Release History</h3>
        <p class="modal-subtitle">Audit trail of all CoinSing release operations and terminal target events</p>
      </div>
      <button type="button" class="close-btn" (click)="closeModal()" aria-label="Close dialog">×</button>
    </div>

    <!-- Modal Body -->
    <div class="modal-body">
      <!-- Filter Bar -->
      <div class="filters-bar">
        <div class="filter-item">
          <label class="filter-label" for="historyFilterDevice">Device:</label>
          <input type="text" id="historyFilterDevice" class="filter-input" placeholder="Filter device..." [(ngModel)]="filterDevice" (input)="applyFilters()" />
        </div>
        <div class="filter-item">
          <label class="filter-label" for="historyFilterVersion">Version:</label>
          <input type="text" id="historyFilterVersion" class="filter-input" placeholder="e.g. 1.2.0" [(ngModel)]="filterVersion" (input)="applyFilters()" />
        </div>
        <div class="filter-item">
          <label class="filter-label" for="historyFilterAction">Action:</label>
          <select id="historyFilterAction" class="filter-select" [(ngModel)]="filterAction" (change)="applyFilters()">
            <option value="">All Actions</option>
            <option value="release">Release (Single/Selected)</option>
            <option value="release_all">Release to All</option>
            <option value="note_edit">Note Edit</option>
            <option value="release_delete">Release Deleted</option>
            <option value="publish">Publish</option>
          </select>
        </div>
        <div class="filter-item">
          <label class="filter-label" for="historyFilterOutcome">Outcome:</label>
          <select id="historyFilterOutcome" class="filter-select" [(ngModel)]="filterOutcome" (change)="applyFilters()">
            <option value="">All Outcomes</option>
            <option value="success">Full Success</option>
            <option value="partial">Partial</option>
            <option value="failed">Failed</option>
          </select>
        </div>
      </div>

      <!-- Loading State -->
      <div *ngIf="isLoading" class="loading-container">
        <div class="spinner"></div>
        <p class="loading-text">Loading release history...</p>
      </div>

      <!-- History Table -->
      <div class="table-scrollable" *ngIf="!isLoading">
        <table class="data-table">
          <thead>
            <tr>
              <th>When (PT)</th>
              <th>Device</th>
              <th>Action</th>
              <th>From</th>
              <th>To</th>
              <th>Options</th>
              <th>By</th>
              <th>Outcome</th>
              <th class="col-actions">Note</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let item of filteredHistory">
              <!-- Main Row -->
              <tr [class.expanded-row]="isRowExpanded(item.id)">
                <!-- When (PT) -->
                <td class="when-cell">
                  {{ formatWhen(item.timestamp) }}
                </td>

                <!-- Device Column -->
                <td>
                  <div class="device-cell-group">
                    <button type="button" class="btn-expand" *ngIf="item.results && item.results.length > 1" (click)="toggleRowExpand(item.id)" [attr.aria-expanded]="isRowExpanded(item.id)">
                      {{ isRowExpanded(item.id) ? '▼' : '▶' }}
                    </button>
                    <span *ngIf="!item.deviceIds || item.deviceIds.length === 0">Fleet-wide</span>
                    <span *ngIf="item.deviceIds && item.deviceIds.length === 1">{{ item.deviceIds[0] }}</span>
                    <span *ngIf="item.deviceIds && item.deviceIds.length > 1">
                      {{ item.deviceIds.length }} devices
                    </span>
                  </div>
                </td>

                <!-- Action Column -->
                <td>
                  <span class="action-badge" [class.badge-release-all]="item.action === 'release_all'" [class.badge-release]="item.action === 'release'" [class.badge-release-delete]="item.action === 'release_delete'">
                    {{ item.action === 'release_all' ? 'Release All' : (item.action === 'release' ? 'Release' : (item.action === 'release_delete' ? 'Release Deleted' : item.action)) }}
                  </span>
                </td>

                <!-- From Version -->
                <td>
                  <span class="version-tag">{{ item.previousVersion ? 'v' + item.previousVersion : '—' }}</span>
                </td>

                <!-- To Version -->
                <td>
                  <span class="version-tag to-version">v{{ item.version }}</span>
                </td>

                <!-- Options Column -->
                <td>
                  <div class="options-badges">
                    <span class="badge-opt opt-force" *ngIf="item.force" title="Force reinstall">Force</span>
                    <span class="badge-opt opt-restart" *ngIf="item.restart" title="Trigger restart">Restart</span>
                    <span class="badge-opt opt-std" *ngIf="!item.force && !item.restart">Standard</span>
                  </div>
                </td>

                <!-- Actor Column -->
                <td>
                  <span class="actor-text">{{ item.actorEmail || 'System' }}</span>
                </td>

                <!-- Outcome Column -->
                <td>
                  <span class="outcome-badge" [class.outcome-success]="isOutcomeSuccess(item)" [class.outcome-failed]="isOutcomeFailed(item)" [class.outcome-partial]="isOutcomePartial(item)">
                    {{ getOutcomeSummary(item) }}
                  </span>
                </td>

                <!-- Note Action Column -->
                <td class="col-actions">
                  <button type="button" class="btn-view-snapshot" *ngIf="item.noteSnapshot" (click)="openNoteSnapshot(item)" title="View note as released">
                    👁️ View Note
                  </button>
                  <span *ngIf="!item.noteSnapshot" class="no-note-text">—</span>
                </td>
              </tr>

              <!-- Expanded Children Device Rows for Bulk Releases -->
              <tr *ngIf="isRowExpanded(item.id) && item.results && item.results.length > 1" class="child-expanded-table-row">
                <td colspan="9" class="expanded-table-cell">
                  <table class="nested-devices-table">
                    <thead>
                      <tr>
                        <th>Device ID</th>
                        <th>Installed Version</th>
                        <th>Is Rollback</th>
                        <th>Result</th>
                        <th>Reason</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let r of item.results">
                        <td><strong>{{ r.deviceId }}</strong></td>
                        <td>{{ r.fromVersion ? 'v' + r.fromVersion : 'Unknown' }}</td>
                        <td>
                          <span *ngIf="r.isRollback" class="badge-rollback">Rollback</span>
                          <span *ngIf="!r.isRollback" class="text-muted">No</span>
                        </td>
                        <td>
                          <span class="pill-badge" [class.status-paid]="r.result === 'accepted'" [class.status-not-paid]="r.result === 'failed'" [class.status-partial]="r.result === 'skipped'">
                            {{ r.result | titlecase }}
                          </span>
                        </td>
                        <td>{{ r.reason || '—' }}</td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </ng-container>

            <!-- Empty State -->
            <tr *ngIf="filteredHistory.length === 0">
              <td colspan="9" class="empty-table-cell">
                No release history records found.
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Pinned Footer -->
    <div class="modal-footer">
      <button type="button" class="btn-cancel" (click)="closeModal()">Close</button>
    </div>

    <!-- Plain-Text Note Snapshot Viewer Modal (AC-10) -->
    <div class="alertdialog-backdrop" *ngIf="viewingNoteSnapshot !== null" role="dialog" aria-modal="true" aria-labelledby="noteSnapshotTitle">
      <div class="alertdialog-box note-snapshot-box">
        <div class="alertdialog-header">
          <h4 id="noteSnapshotTitle" class="confirm-title">📝 Release Note as Released — v{{ viewingNoteVersion }}</h4>
          <button type="button" class="close-btn" (click)="closeNoteSnapshot()">×</button>
        </div>
        <div class="alertdialog-body note-snapshot-body">
          <pre class="note-plain-text">{{ viewingNoteSnapshot }}</pre>
        </div>
        <div class="alertdialog-footer">
          <button type="button" class="btn-cancel" (click)="closeNoteSnapshot()">Close</button>
        </div>
      </div>
    </div>
  </div>
</div>

